<template>
  <dialog
    ref="dialogEl"
    class="scrim"
    aria-labelledby="push-ask-title"
    @cancel.prevent="emit('later')"
    @click="onScrimClick"
  >
    <div class="panel">
      <h2 id="push-ask-title">{{ t('push.title') }}</h2>
      <p>{{ t('push.body') }}</p>
      <div class="actions">
        <button type="button" class="md-btn-tonal" @click="emit('enable')">
          {{ t('push.enable') }}
        </button>
        <button type="button" class="text-btn" @click="emit('later')">
          {{ t('push.later') }}
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from '../i18n/t'

const emit = defineEmits<{
  enable: []
  later: []
}>()

const { t } = useI18n()
const dialogEl = ref<HTMLDialogElement | null>(null)

function onScrimClick(event: MouseEvent): void {
  if (event.target === dialogEl.value) emit('later')
}

onMounted(() => {
  dialogEl.value?.showModal()
})
</script>

<style scoped>
.scrim {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  margin: 0;
  padding: max(16px, env(safe-area-inset-top))
    max(16px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom))
    max(16px, env(safe-area-inset-left));
  border: 0;
  background: transparent;
  overflow: auto;
}

.scrim::backdrop {
  background: var(--md-scrim);
}

.panel {
  width: min(420px, calc(100vw - 32px));
  padding: 24px;
  border-radius: 28px;
  background: var(--md-sys-color-surface-container);
  color: var(--md-sys-color-on-surface);
  box-shadow: var(--md-elevation-2);
}

h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.3;
}

p {
  margin: 12px 0 0;
  color: var(--md-sys-color-on-surface-variant);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
}

.md-btn-tonal,
.text-btn {
  min-height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 20px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.md-btn-tonal {
  background: var(--md-sys-color-primary);
  color: var(--md-sys-color-on-primary);
}

.text-btn {
  background: transparent;
  color: var(--md-sys-color-primary);
}
</style>
